import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'

import { Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'transportation'>

export const Transportation = ({ transportation }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-4">
      <Heading>{t('transportation.title')}</Heading>
      <p className="typo-body2 font-normal whitespace-break-spaces text-gray-900">
        {transportation}
      </p>
    </section>
  )
}
